"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPostEventEndpoints = createPostEventEndpoints;
/**
 * Katılım belgesi ve etkinlik sonrası anket, KURUM uçları (Story 2-3).
 *
 * Okuma her aktif üyeye açıktır (görüntüleyici dahil), yazma `event:manage`
 * ister. Kurucu uçları yalnız TASLAK ankette çalışır; yayından sonra 409.
 */
function createPostEventEndpoints(client) {
    return {
        postEvent: {
            certificateSettings: (eventId) => client.call('/events/{eventId}/manage/certificate-settings', 'get', {
                path: { eventId },
            }),
            updateCertificateSettings: (eventId, input) => client.call('/events/{eventId}/manage/certificate-settings', 'put', {
                path: { eventId },
                body: input,
            }),
            survey: (eventId) => client.call('/events/{eventId}/manage/survey', 'get', { path: { eventId } }),
            /** Taslak dört hazır soruyla doğar; etkinlik başına tek anket (ikincisi 409). */
            createSurvey: (eventId) => client.call('/events/{eventId}/manage/survey', 'post', { path: { eventId } }),
            publishSurvey: (eventId) => client.call('/events/{eventId}/manage/survey/publish', 'post', {
                path: { eventId },
            }),
            addQuestion: (eventId, input) => client.call('/events/{eventId}/manage/survey/questions', 'post', {
                path: { eventId },
                body: input,
            }),
            updateQuestion: (eventId, questionId, input) => client.call('/events/{eventId}/manage/survey/questions/{questionId}', 'put', {
                path: { eventId, questionId },
                body: input,
            }),
            removeQuestion: (eventId, questionId) => client.call('/events/{eventId}/manage/survey/questions/{questionId}', 'delete', {
                path: { eventId, questionId },
            }),
            reorderQuestions: (eventId, questionIds) => client.call('/events/{eventId}/manage/survey/questions/reorder', 'post', {
                path: { eventId },
                body: { questionIds: [...questionIds] },
            }),
            restorePresets: (eventId) => client.call('/events/{eventId}/manage/survey/questions/presets', 'post', {
                path: { eventId },
            }),
            /** Toplu sonuç (Story 7): sayılar 5'in katı, kişi bazlı alan yok. */
            surveyResults: (eventId) => client.call('/events/{eventId}/manage/survey/results', 'get', { path: { eventId } }),
            // --- Katılımcı (Story 4). Uygun olmayan katılımcıya 403. -------------
            /** Yalnız çağıranın uygun olduğu etkinliklerin özeti; belge kaydı üretmez. */
            participantStatus: (eventIds) => client.call('/users/me/post-event', 'get', { query: { eventIds: [...eventIds] } }),
            participantSurvey: (eventId) => client.call('/events/{eventId}/survey', 'get', { path: { eventId } }),
            submitSurvey: (eventId, input) => client.call('/events/{eventId}/survey/responses', 'post', {
                path: { eventId },
                body: input,
            }),
        },
    };
}
//# sourceMappingURL=post-event.js.map